/**
 * Layout1: 100% 1col
 * Layout2: auto 1row
 */
export const layoutList = [
  { key: "layout1", value: 1, text: "Single Column" },
  { key: "layout2", value: 2, text: "Spread Evenly" },
];
